// extracted by mini-css-extract-plugin
module.exports = {"sideDrawer":"SideDrawer_sideDrawer__2G033","open":"SideDrawer_open__3RfjX","close":"SideDrawer_close__1vXej","logo":"SideDrawer_logo__29OS3"};